import {AppAction} from "../actions/appActions";

export interface IEventType {
	label: string;
	value: string;
}

interface AppState {
	cities: string[] | null;
	eventTypes: IEventType[] | null;
	districtBounds: any | null;
}

const initialState: AppState = {
	cities: null,
	eventTypes: null,
	districtBounds: null,
};

const appReducer = (state = initialState, action: AppAction): AppState => {
	switch (action.type) {
		case 'SAVE_CITIES':
			return {...state, cities: action.payload};
		case 'SAVE_EVENT_TYPES':
			return {...state, eventTypes: action.payload};
		case 'SAVE_DISTRICT_BOUNDS':
			return {...state, districtBounds: action.payload};
		case 'RESET_APP_CACHE':
			return initialState;
		default:
			return state;
	}
};

export default appReducer;